import React from 'react';
import { SEO } from '../components/seo/SEO';
import { MarkdownPage } from '../components/content/MarkdownPage';
import content from '../content/insights/sap-ai-modernization.md?raw';

export const InsightsSapAi: React.FC = () => {
  return (
    <>
      <SEO
        title="SAP + AI Modernization"
        description="How to align SAP/ERP with AI assistants, transports, and Fiori delivery with guardrails."
        canonical="/insights/sap-ai-modernization"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'SAP + AI Modernization',
          description:
            'How to align SAP/ERP with AI assistants, transports, and Fiori delivery with guardrails.',
          author: { '@type': 'Organization', name: 'Integrova AI GmbH' },
          publisher: {
            '@type': 'Organization',
            name: 'Integrova AI GmbH',
            logo: { '@type': 'ImageObject', url: 'https://integrovaai.de/og-default.png' },
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://integrovaai.de/insights/sap-ai-modernization' },
          datePublished: '2025-12-20',
          dateModified: '2025-12-20',
        }}
      />
      <MarkdownPage
        title="SAP + AI Modernization"
        eyebrow="Insights"
        content={content}
      />
    </>
  );
};

export default InsightsSapAi;
